import type {CourseApiModel} from '../../api/course';
import type {ApiListResponse} from '../../api/types';
import type {BNCourseApiModel} from '../../api/types/bnrks/models';
import type {CoreCoachCoursesListParams} from '../../api/types/core/methods';
import type {CoreCourseApiModel} from '../../api/types/core/models';
import type {ApiRpcQuery} from '../../api/utils/apiRequest';

import {currentUserStore} from '../../api/user';
import {apiRequest} from '../../api/utils/apiRequest';
import {isCourseIndividual} from '../../utils/entity/course';
import {envManager} from '../../utils/env';

export const getSubscriptionLimits = async () => {
  const {_items: courses}: ApiListResponse<CourseApiModel> =
    await apiRequest<CoreCoachCoursesListParams>({
      method: 'coach.courses.list',
      params: {
        limit:
          TRIAL_MAX_ONGOING_COURSES.group +
          TRIAL_MAX_ONGOING_COURSES.individual,

        query: [
          // @ts-expect-error: TODO: describe why
          envManager.isB2b
            ? (['status', 'in', ['ongoing', 'archived']] as ApiRpcQuery<
                BNCourseApiModel,
                'status'
              >)
            : ([
                'status',
                'in',
                ['ongoing', 'paused', 'archived'],
              ] as ApiRpcQuery<CoreCourseApiModel, 'status'>),
          ['coach_ids', 'in', [currentUserStore.user!._id]],
          [
            'hidden_for_ids',
            '!contains',
            currentUserStore.user?._id ? [currentUserStore.user._id] : [],
          ],
        ],
        show_deleted: true,
      },
    });

  const {groupCoursesAmount, individualCoursesAmount} =
    computeCoursesAmount(courses);

  const isIndividualLimitReached =
    individualCoursesAmount >= TRIAL_MAX_ONGOING_COURSES.individual;

  const isGroupLimitReached =
    groupCoursesAmount >= TRIAL_MAX_ONGOING_COURSES.group;

  const isLimitReached = isIndividualLimitReached || isGroupLimitReached;

  return {
    groupCoursesAmount,
    individualCoursesAmount,
    isGroupLimitReached,
    isIndividualLimitReached,
    isLimitReached,
  };
};

export const TRIAL_MAX_ONGOING_COURSES = {
  group: 1,
  individual: 2,
};

const computeCoursesAmount = (courses: CourseApiModel[]) => {
  let individualCoursesAmount = 0;
  let groupCoursesAmount = 0;

  courses.forEach(course =>
    isCourseIndividual(course)
      ? (individualCoursesAmount += 1)
      : (groupCoursesAmount += 1),
  );

  return {groupCoursesAmount, individualCoursesAmount};
};
